import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, Validators } from '@angular/forms';

@Directive({
  selector: 'input[appDobValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: DobValidatorDirective, multi: true }
  ]
})
export class DobValidatorDirective implements Validator {
  @Input() yearsBack = 110;
  @Input() doMinorCheck = true;

  private reggy = new RegExp(/^\d{4}-\d{2}-\d{2}$/);

  validate(control: AbstractControl): { [key: string]: any } {
    const dateString = control.value;

    if (!dateString) {
      // Nothing to see here folks
      return null;
    }

    const rslt = Validators.pattern(this.reggy)(control);

    // If the input is invalid, then just return validation issue
    if (rslt) {
      // console.log('Not Passing validation regex')
      return { invalidDate: true };
    }

    // Ok, the input is a valid date, but, we have to do aditional checks
    const dobbo = new Date(dateString);

    const dNum = dobbo.getTime();

    if (!dNum && dNum !== 0) {
      // NaN value, Invalid date
      return { invalidDate: true };
    }

    var year = dobbo.getFullYear();
    var rightNow = new Date().getFullYear();
    if((rightNow - year) >= this.yearsBack) return { invalidDate: true };



    if (this.doMinorCheck) {
      let minorAgeCutoff = new Date();
      minorAgeCutoff.setFullYear(new Date().getFullYear() - 18);

      if (dobbo > minorAgeCutoff) {
        return { isMinor: true };
      }

      if (dobbo.toISOString().slice(0, 10) !== dateString) {
        return { invalidDate: true };
      }

      const today = new Date();
      const yobbo = dobbo.getFullYear();
      const hundo = today.getFullYear() - this.yearsBack;

      const olderThan: boolean = yobbo < hundo;

      // if the DOB is older than 100 years or if the date is after today, we may have a problem
      if (olderThan || dateString > today) {
        return { invalidDate: true };
      }
    }

    return null;
  }
}
